import './styles/AccordionStyle.scss';

import { ExpandMore } from '@mui/icons-material';
import {
  Grid,
  Accordion,
  AccordionSummary,
  FormControlLabel,
  Checkbox,
  AccordionDetails,
  AccordionDetailsProps
} from '@mui/material';

import { useEffect, useState } from 'react';

interface Props extends AccordionDetailsProps {
  title: string;
  checked: boolean;
  icon: React.ReactNode;
  type: 'recipient' | 'semester';
  handleClickAll: (add: boolean) => void;
  amountSelected: number;
  active?: boolean;
}

export enum DefaultAccordionEnum {
  RECIPIENT = 'recipient',
  SEMESTER = 'semester'
}

export const DefaultAccordion = (props: Props) => {
  const [isExpanded, setExpanded] = useState<boolean>(props.checked);

  const handleChange = () => {
    setExpanded(old => !old);
  };

  useEffect(() => {
    if (props.checked) {
      setExpanded(true);
    }
  }, [props.checked]);

  return (
    <Grid item xs={12} className="accordion">
      <Accordion elevation={0} expanded={isExpanded} onChange={handleChange}>
        <AccordionSummary expandIcon={<ExpandMore />} className="accordion__summary">
          <FormControlLabel
            label={
              <span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                {props.icon}
                {props.title}
                {props.amountSelected > 0 ? `: ${props.amountSelected}` : ''}
              </span>
            }
            onClick={event => event.stopPropagation()}
            onFocus={event => event.stopPropagation()}
            control={
              <Checkbox
                checked={props.checked}
                onClick={e => e.stopPropagation()}
                onChange={e => props.handleClickAll(e.target.checked)}
              />
            }
          />
        </AccordionSummary>
        <AccordionDetails>{props.children}</AccordionDetails>
      </Accordion>
    </Grid>
  );
};
